import { render, staticRenderFns } from "./RecordsStats.vue?vue&type=template&id=2b9563f0&scoped=true&"
import script from "./RecordsStats.vue?vue&type=script&lang=js&"
export * from "./RecordsStats.vue?vue&type=script&lang=js&"
import style0 from "./RecordsStats.vue?vue&type=style&index=0&id=2b9563f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9563f0",
  null
  
)

export default component.exports